<template>
  <section class="card border-0">
    <div class="card-body">
      <h6 class="mb-3">{{ title }}</h6>

      <div class="d-flex align-items-center mb-3">
        <span class="me-2 text-muted small">현재</span>
        <span class="text-dark px-3 py-2 small">{{ displayValue }}</span>
      </div>

      <input
        type="range"
        class="form-range carbon-slider"
        :min="innerMin"
        :max="innerMax"
        :step="step"
        :value="modelValueNumber"
        @input="onInput"
      />

      <div class="d-flex justify-content-between">
        <small class="text-muted">{{ innerMin }} kgCO₂</small>
        <small class="text-muted">{{ innerMax }} kgCO₂</small>
      </div>

      <label v-if="hint" class="text-muted small mt-3 mb-0">
        {{ hint }}
      </label>
    </div>
  </section>
</template>

<script>
export default {
  name: "Co2Slider",
  props: {
    /* v-model */
    modelValue: { type: [Number, String], default: 0 },

    /* 표시 텍스트 */
    title: { type: String, default: "탄소배출량" },
    hint: { type: String, default: "드래그로 탄소 배출량을 조절하세요." },

    /* 범위/스텝 */
    min: { type: Number, default: 0 },
    max: { type: Number, default: 100 },
    step: { type: Number, default: 0.01 },

    /* 값이 max를 넘으면 자동으로 확장할지 */
    autoExpandMax: { type: Boolean, default: true },
    expandUnit: { type: Number, default: 50 }, // 50 단위로 올림
  },
  emits: ["update:modelValue", "change"],
  data() {
    return { innerMin: this.min, innerMax: this.max };
  },
  computed: {
    modelValueNumber() {
      const n = Number(this.modelValue ?? 0);
      return Number.isFinite(n) ? n : 0;
    },
    displayValue() {
      return `${this.modelValueNumber.toFixed(2)} kgCO₂`;
    },
  },
  watch: {
    min(v) { this.innerMin = v; },
    max(v) { this.innerMax = v; },
    modelValueNumber(v) {
      if (!this.autoExpandMax) return;
      if (v > this.innerMax) {
        const unit = this.expandUnit || 50;
        this.innerMax = Math.ceil(v / unit) * unit;
      }
    },
  },
  methods: {
    onInput(e) {
      const val = Number(e.target.value);
      const fixed = Number(val.toFixed(2));
      this.$emit("update:modelValue", fixed);
      this.$emit("change", fixed);
    },
  },
};
</script>

<style scoped>
/* 슬라이더 트랙/썸 커스텀 (기존 스타일 이동) */
.carbon-slider { height: 2rem; }
.carbon-slider::-webkit-slider-runnable-track {
  height: 8px; border-radius: 9999px;
  background: linear-gradient(90deg, #22c55e, #f59e0b, #ef4444);
  opacity: .85;
}
.carbon-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 18px; height: 18px; margin-top: -5px;
  background: #fff; border: 2px solid #111827; border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0,0,0,.2);
}
.carbon-slider:focus { outline: none; }
.carbon-slider::-moz-range-track {
  height: 8px; border-radius: 9999px;
  background: linear-gradient(90deg, #22c55e, #f59e0b, #ef4444);
  opacity: .85;
}
.carbon-slider::-moz-range-thumb {
  width: 18px; height: 18px; background: #fff;
  border: 2px solid #111827; border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0,0,0,.2);
}
</style>
